import axios from 'axios';
export const commonHeaders = {
    'content-type': 'application/json',
};
const defaultConf = {
    headers: commonHeaders,
};
export const generateConf = (conf, onUnauthorized) => {
    const HTTP = axios.create({
        ...defaultConf,
        ...conf,
    });
    HTTP.interceptors.response.use((r) => r, (err) => {
        console.error('API ERROR:', err.response || err);
        if (err.response.status === 401 && onUnauthorized) {
            onUnauthorized();
        }
        return Promise.reject(err.response || err);
    });
    return HTTP;
};
export const setAuth = (tenantId, authTokens, ...http) => {
    const { token, impersonationToken } = authTokens;
    return http.map((h) => {
        h.defaults.headers.authorization = `Bearer ${token}`;
        h.defaults.headers['x-tenant-id'] = tenantId;
        if (impersonationToken) {
            h.defaults.headers['x-impersonation'] = `Bearer ${impersonationToken}`;
        }
    });
};
//# sourceMappingURL=axios.js.map